import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import tdocsBridge from '@src/slide/infrastructure/module/independent/tdocsBridge/tdocsBridge';
import { EDITOR_INPUT_CLASS_NAME } from '@tencent/alloy-editor';

/**
 * 在文字编辑器中管理 ipad 外设键盘相关事件的类
 */
export class IpadExternalKeyEventHandler {
    // 标记是否注册过
    private static hasRegistered = false;
    // 标记 registerShortcutKeyEvent js api 是否已经调用
    private static hasInvoked = false;

    /**
     * 注册事件
     */
    public static register(): void {
        if (this.hasRegistered) {
            return;
        }
        if (this.isNeedExternalKeyEvent()) {
            this.invokeShortcut();
            window.mqq?.addEventListener('shortcutKeyEvent', this.dispatchKeyboardEvent);
        }
        this.hasRegistered = true;
    }

    /**
     * 解绑事件
     */
    public static unRegister(): void {
        this.hasRegistered = false;
        if (this.isNeedExternalKeyEvent()) {
            window.mqq?.removeEventListener('shortcutKeyEvent', this.dispatchKeyboardEvent);
        }
    }

    /**
     * 手动触发键盘事件
     */
    private static dispatchKeyboardEvent = (e): void => {
        const targetElement = document.querySelector(`.${EDITOR_INPUT_CLASS_NAME}`) as HTMLInputElement;
        if (!targetElement) {
            return;
        }
        if (e.input === 'up') {
            targetElement?.dispatchEvent(createKeyboardEvent('ArrowUp', 38));
        }
        if (e.input === 'down') {
            targetElement?.dispatchEvent(createKeyboardEvent('ArrowDown', 40));
        }
        if (e.input === 'left') {
            targetElement?.dispatchEvent(createKeyboardEvent('ArrowLeft', 37));
        }
        if (e.input === 'right') {
            targetElement?.dispatchEvent(createKeyboardEvent('ArrowRight', 39));
        }
    };

    private static invokeShortcut() {
        if (this.hasInvoked) {
            return;
        }
        // 调用 js api
        tdocsBridge.invokeDocx('registerShortcutKeyEvent', {
            shortcutKey: [
                { input: 'left', modifier: '' },
                { input: 'right', modifier: '' },
                { input: 'up', modifier: '' },
                { input: 'down', modifier: '' },
            ],
        });
        this.hasInvoked = true;
    }

    /**
     * 判断是否需要额外的模拟键盘事件
     */
    private static isNeedExternalKeyEvent(): boolean {
        return window.mqq && browser.isIPad && browser.isTencentDocApp;
    }
}


/**
 * 生成键盘事件对象
 */
function createKeyboardEvent(key: string, keycode: number) {
    return new KeyboardEvent('keydown', {
        altKey: false,
        bubbles: true,
        cancelable: true,
        charCode: 0,
        code: key,
        ctrlKey: false,
        detail: 0,
        key,
        keyCode: keycode,
        metaKey: false,
        repeat: false,
        shiftKey: false,
    });
}
